// extracted by mini-css-extract-plugin
export default {"traineeDetailsContainer":"TraineeDetails_traineeDetailsContainer__Q6r+z","components":"TraineeDetails_components__H-X1Q"};